module.exports = __webpack_public_path__ + "assets/img/huoban.89bf4bac.png";